@if (dragActionColumns.length) {
  <div
    class="fixed bottom-3 left-3 right-3 z-50 transition-all duration-150 md:left-24"
    [ngClass]="isDragging ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'"
    aria-hidden="true"
  >
    <div class="grid gap-2" [style.gridTemplateColumns]="dragActionGridTemplate(visibleDragActionColumns)">
      <div
        cdkDropList
        class="flex min-h-16 origin-bottom items-center justify-center rounded-lg border-2 px-5 py-4 shadow-lg transition-all duration-150 md:justify-start [&_.cdk-drag-placeholder]:!hidden [&_.cdk-drag-placeholder]:!h-0 [&_.cdk-drag-placeholder]:!opacity-0"
        [ngClass]="activeDragActionId === deleteDropZoneId ? 'scale-y-125 shadow-2xl ring-2 ring-gray-500/35' : 'scale-y-100 ring-0'"
        [id]="deleteDropZoneId"
        [cdkDropListData]="dragActionCards"
        [cdkDropListConnectedTo]="deleteDragActionConnectedTo()"
        [cdkDropListSortingDisabled]="true"
        [style.borderColor]="deleteDragActionBorderColor"
        [style.background]="deleteDragActionBackground"
        (cdkDropListEntered)="onDeleteDragActionEnter()"
        (cdkDropListExited)="onDeleteDragActionExit()"
        (cdkDropListDropped)="onDeleteDragActionDrop($event)"
      >
        <app-icon class="!h-7 !w-7 shrink-0 !text-[28px] !leading-7 text-gray-700">delete_outline</app-icon>
        <span class="min-w-0">
          <span class="block truncate text-sm font-bold text-gray-700 md:text-base">
            {{ 'delete' | translate }}
          </span>
        </span>
      </div>

      @for (column of visibleDragActionColumns; track dragActionDropZoneId(column)) {
        <div
          cdkDropList
          class="flex min-h-16 origin-bottom items-center justify-center rounded-lg border-2 px-5 py-4 shadow-lg transition-all duration-150 md:justify-start [&_.cdk-drag-placeholder]:!hidden [&_.cdk-drag-placeholder]:!h-0 [&_.cdk-drag-placeholder]:!opacity-0"
          [ngClass]="activeDragActionId === column.id ? 'scale-y-125 shadow-2xl ring-2 ring-white/45' : 'scale-y-100 ring-0'"
          [id]="dragActionDropZoneId(column)"
          [cdkDropListData]="dragActionCards"
          [cdkDropListConnectedTo]="dragActionConnectedTo(column)"
          [cdkDropListSortingDisabled]="true"
          [style.borderColor]="activeDragActionId === column.id ? column.color.background : 'transparent'"
          [style.background]="dragActionBackground(column)"
          (cdkDropListEntered)="onDragActionEnter(column)"
          (cdkDropListExited)="onDragActionExit(column)"
          (cdkDropListDropped)="onDragActionDrop($event, column)"
        >
          <app-icon class="!h-7 !w-7 shrink-0 !text-[28px] !leading-7" [style.color]="column.color.background">
            {{ dragActionIcon(column) }}
          </app-icon>
          <span class="min-w-0">
            <span class="block truncate text-sm font-bold md:text-base" [style.color]="column.color.background">
              {{ dragActionLabel(column) }}
            </span>
          </span>
        </div>
      }
    </div>
  </div>
}
